var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltenarWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.2 117.3",
    style: {
      enableBackground: "new 0 0 362.2 117.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000084501699748578995850000001493949176308076935_);}\n\t.st2{fill:url(#SVGID_00000124862380778078389960000015773639049758325908_);}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.875,
    y1: 55.05,
    x2: 73.9,
    y2: 55.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02A7B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5D2CC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.9,27.1c-2.5,0-5.1,1.3-6.4,3.4c-0.3,0.3-16.2,24.5-17,25.9c-0.6,1-1.1,2-1.4,3.1c-0.3,1.2-0.3,2.5,0,3.7 c0.2,0.9,0.7,1.7,1.1,2.5C29.6,70,31.6,73,34,77.3c1.1,1.9,2.1,3.8,3.3,5.7c-0.4-2,0.3-4,1.3-5.7c1.2-2.1,30.7-47.2,31.3-47.9 c1.6-2.1,4-2.3,4-2.3S54.3,27.1,50.9,27.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093864494186741686150000000683961535094190781_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7,
    y1: 56.2313,
    x2: 109.5,
    y2: 56.2313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1525,
    style: {
      stopColor: "#016385"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98D2CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093864494186741686150000000683961535094190781_)"
    },
    d: "M108.9,84.3l0.6-0.5 c0,0-29.2-51.3-30.4-53.2c-0.5-0.9-1.4-1.7-2.4-2.1c-1.5-0.6-3.3-0.4-4.6,0.6c-0.6,0.4-1,0.9-1.4,1.5c-1.2,1.7-10,15.2-10,15.2 L108.9,84.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040552340195348213710000007744098461290016142_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6992,
    y1: 78.4194,
    x2: 84.4,
    y2: 78.4194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1525,
    style: {
      stopColor: "#016385"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98D2CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040552340195348213710000007744098461290016142_)"
    },
    d: "M84.4,68.6H46.1c0,0-7.1,10.2-7.3,12.2 c-0.3,1.6,0.1,3.3,0.8,4.7c1.9,3.2,6,3.5,9.7,1.4c7.3-4.1,35-17.6,35-17.6L84.4,68.6L84.4,68.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206,50.7V68c0,4.2,3.4,7.7,7.7,7.7h17.7v-3.6c0-0.6-0.5-1-1-1h-16.7c-1.5,0-2.7-1.2-2.7-2.7v-6.7h16 c0.6,0,1-0.5,1-1v-3.6h-15.5c-0.6,0-1.1,0.1-1.6,0.4v-7c0-1.5,1.2-2.7,2.7-2.7h16.7c0.6,0,1-0.5,1-1v-3.6h-17.7 C209.5,43.1,206,46.5,206,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M263.8,44.2c0,0.8,0.2,17.5,0.5,23.6L249,45.6c-0.7-1.3-2.5-2.4-4-2.4h-4.8c-0.6,0-1,0.5-1,1v31.5h3.9 c0.6,0,1-0.5,1-1V47.8h0.2c0.3,0,0.6,0.2,0.7,0.4L263.4,75c0.2,0.4,0.8,0.7,1.2,0.7h4.1V43.2h-3.9 C264.3,43.2,263.8,43.7,263.8,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.8,43.1h-4.6v28.5c0,2.3,1.9,4.1,4.1,4.1h17.5v-4.6h-17.1v-28H157.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "171.3,47.6 184.4,47.6 184.4,75.7 189,75.7 189,47.6 201.7,47.6 201.7,43.1 171.3,43.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.7,64.1c4.3-1.4,6.8-5.1,6.8-10.2c0-6.8-4.1-10.8-10.9-10.8h-8.8c-5.1,0-9.3,4.2-9.3,9.3v23.4h3.5 c0.6,0,1-0.5,1-1v-10h12.6l6.8,10.5c0.2,0.4,0.6,0.6,1.1,0.6h4.8L329.7,64.1z M312,60.2v-7.8c0-3.1,1.6-4.7,4.7-4.7h8.8 c4.1,0,6.3,2.2,6.3,6.3s-2.2,6.3-6.3,6.3L312,60.2L312,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.5,65.3c-0.4-0.8-1.1-1.3-2-1.3h-12.7l7.5-16.3l-1.7-5.1c-0.1-0.3-0.6-0.4-0.7-0.1l-1.1,2.1l-14.5,31.1 h4.4c0.4,0,0.8-0.3,1-0.6l3-6.5H145L143.5,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287,42.4c-0.1-0.3-0.5-0.2-0.6,0l-1.8,5.3l7.5,16.3h-12.7c-0.9,0-1.7,0.5-2,1.3l-1.4,3.3h18.3l3,6.5 c0.2,0.4,0.6,0.6,1,0.6h4.4l-14.5-31.1L287,42.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltenarWhitecolor);
export default __webpack_public_path__ + "static/media/ALTENAR_white+color.5229b9b04950202a45430f465ac81aef.svg";
export { ForwardRef as ReactComponent };